import { useEffect } from "react";
import { useSelector } from "react-redux";
import { capitalize } from "lodash";

const MyAccount = () => {
  const { currentUser, userType, userId } = useSelector(
    (state) => state.signinSliceReducer
  );
  const { currentEntity } = useSelector((state) => state.entitySliceReducer);

  useEffect(() => {
    document.title = "My Account - Ample Hire";
  }, []);

  const initials = currentUser
    ? currentUser
        .split(" ")
        .map((w) => w[0])
        .join("")
        .toUpperCase()
        .slice(0, 2)
    : "U";

  const email = localStorage.getItem("e_user_email") || "—";

  const infoFields = [
    { label: "Full Name", value: currentUser || "—" },
    { label: "Email Address", value: email },
    { label: "User ID", value: userId || "—" },
    { label: "Role", value: capitalize(userType) || "—" },
    { label: "Organization", value: currentEntity?.businessName || "—" },
    {
      label: "Account Status",
      value: <span className="badge badge-success">Active</span>,
    },
  ];

  return (
    <div className="p-6 bg-vf-bg min-h-full">
      {/* Page header */}
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-vf-base">My Account</h1>
        <p className="mt-1 text-sm text-vf-muted">
          View your profile information and account details.
        </p>
      </div>

      {/* Profile header */}
      <div className="card p-6 mb-6">
        <div className="flex items-center gap-5">
          <div className="w-16 h-16 rounded-full bg-vf-primary text-white flex items-center justify-center text-xl font-semibold shrink-0">
            {initials}
          </div>
          <div>
            <div className="text-lg font-semibold text-vf-base">
              {currentUser || "User"}
            </div>
            <span className="badge mt-1 inline-block">
              {capitalize(userType) || "Admin"}
            </span>
          </div>
        </div>
      </div>

      {/* Info grid */}
      <div className="card p-6">
        <h2 className="text-base font-semibold text-vf-base mb-5">
          Account Information
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5">
          {infoFields.map((field) => (
            <div key={field.label}>
              <div className="input-label mb-1">{field.label}</div>
              <div className="text-sm text-vf-base">{field.value}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MyAccount;
